export default __webpack_public_path__ + "static/1-11d53092d6385158a84e3746c97ae131.png";